import api from './api/api';

export const cadastroCredenciado = async (cadastro) => {
  return api().post('/publico/credenciado/cadastrar', cadastro)
}

export const findCredenciadosByFiltro = async (filtro) => {
  return api().post('/credenciado/findByFiltro', filtro)
}

export const findProcessosByFiltro = async (filtro) => {
  return api().post('/processo/filtro', filtro)
}

export const findPessoaByCpf = async (cpf) => {
  return api().get(`/publico/credenciado/findPessoaByCpf/${cpf}`)
}

export const editarCredenciado = async (solicitacao) => {
  return api().put('/credenciado/alterar', solicitacao)
}

export const exportCSVListagemCredenciados = () => {
  return api().post('/credenciado/listagem/exportar', null, {responseType: 'blob'})
}
